import { CompositionDetails } from "../composition-types";
import { compositionIds } from "../composition-ids";
import { RhythmPortion } from "../../rhythms/rhythm-types";

const portions: RhythmPortion[] = [
    {
        beatsPerCycle: 7,
        beatsPerMinute: 128,
        startTime: 41,
    },
    {
        beatsPerCycle: 7,
        beatsPerMinute: 128,
        startTime: 96.5,
    },
    {
        beatsPerCycle: 7,
        beatsPerMinute: 130,
        startTime: 149,
    },
    {
        beatsPerCycle: 7,
        beatsPerMinute: 122,
        startTime: 213.5,
    },
    {
        beatsPerCycle: 7,
        beatsPerMinute: 132,
        startTime: 230.5,
    },
    {
        beatsPerCycle: 7,
        beatsPerMinute: 126,
        startTime: 297.5,
    },
    {
        beatsPerCycle: 7,
        beatsPerMinute: 130,
        startTime: 317.5,
    },
    {
        beatsPerCycle: 7,
        beatsPerMinute: 132,
        startTime: 336.75,
    },
    {
        beatsPerCycle: 7,
        beatsPerMinute: 136,
        startTime: 359,
    },
    {
        beatsPerCycle: 7,
        beatsPerMinute: 132,
        startTime: 368.25,
    },
    {
        beatsPerCycle: 7,
        beatsPerMinute: 0,
        startTime: 394,
    },
];

export const hePraanMaithili: CompositionDetails = {
    id: compositionIds.hePraanMaithili,
    rhythmSpec: {
        rhythmPortions: portions,
    },
    media: {
        youtubeVideoId: "7AUBZixI40E",
    },
    displayName: "He Praan Naath Gobinde - Maithili Thakur Ji",
    taals: ["roopak"],
};
